import React, { useEffect, useState } from 'react';
import { createStyles, Flex, Box, Portal, Overlay, Loader, Image, useMantineTheme } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { getSupports, deleteSupport } from '../../services/api.service';
import DeleteButton from '../buttons/DeleteButton';
import DataTable from '../table/DataTable';
import TableHeader from '../table/TableHeader';
import CustomModal from '../modal/CustomModal';
import SupportForm from '../forms/SupportForm';
import { useEntityManager } from '../../hooks/useEntityManager';

// Custom styles
const useStyles = createStyles((theme) => ({
  container: {
    padding: theme.spacing.md,
    height: '100%',
  },
  imagePreview: {
    padding: 3,
    border: `1px solid ${theme.colorScheme === 'dark' ? theme.white : theme.black}`,
    borderRadius: theme.radius.sm,
    backgroundColor: theme.colorScheme === 'dark' ? theme.white : theme.black,
  }
}));

const Supports = () => {

  // State and hooks
  const [opened, { open, close }] = useDisclosure(false);
  const theme = useMantineTheme();
  const { classes } = useStyles();
  const {
    isLoading,
    search,
    handleSearchChange,
    filteredEntities: filteredSupports,
    isEdit,
    editItem: supportEdit,
    toggleEdit: toggleSupportEdit,
    handleCloseModal,
    openDeleteModal,
    isDeleteLoading,
  } = useEntityManager({
    fetchEntities: getSupports,
    deleteEntity: deleteSupport,
    entityName: 'Apoyante',
    article: 'eliminado',
    filterKey: 'name',
  });

  const columns = [
    { label: 'ID', key: 'id' },
    { label: 'Nombre', key: 'name' },
    { label: 'Imagen', key: 'image' },
    { label: '', key: 'actions' },
  ];

  const renderRow = (item) => (
    <tr
      key={item.id}
      onClick={(e) => {
        toggleSupportEdit(e, item);
        open();
      }}
      style={{ cursor: 'pointer' }}
    >
      <td>{item.id}</td>
      <td>{item.name}</td>
      <td>
        <Image
          src={item.image}
          alt="Logo"
          radius={theme.radius.sm}
          maw={100}
          className={classes.imagePreview}
        />
      </td>
      <td>
        <DeleteButton
          onClick={(e) => {
            e.stopPropagation();
            openDeleteModal(item.id);
          }}
        />
      </td>
    </tr>
  );

  return (
    <>
      {/* Modal */}
      <CustomModal opened={opened}>
        <SupportForm
          closeModal={() => {
            close();
            handleCloseModal();
          }}
          isEdit={isEdit}
          support={supportEdit}
        />
      </CustomModal>
      {/* Delete Loader */}
      {isDeleteLoading ?
        <Portal>
          <Overlay
                sx={{
                  position: "fixed",
                  top: 0,
                  left: 0,
                  width: "100vw",
                  height: "100vh",
                  zIndex: 999,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
                blur={15}
              >            
            <Loader size={100} />
          </Overlay>
        </Portal>
        : null}
      <Box className="mainContainer">
        {/* Content */}
        <Flex
          direction="column"
          justify="space-between"
          className={classes.container}
        >
          <TableHeader
            title="Con el apoyo de:"
            buttonLabel="Nuevo apoyante"
            onButtonClick={open}
            searchValue={search}
            onSearchChange={handleSearchChange}
            searchPlaceholder="Buscar apoyantes"
          />
          <Flex direction="column">
            {/* Table */}
            <DataTable
              data={filteredSupports}
              columns={columns}
              renderRow={renderRow}
              loading={isLoading}
            />
          </Flex>
        </Flex>
      </Box>
    </>
  );

}

export default Supports;